import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Overlay } from 'telia-front-react';
import RouteStore from '../stores/RouteStore';

interface ContentPageOverlayProps {
  routeStore?: RouteStore;
}

function ContentPageOverlay(props: ContentPageOverlayProps): JSX.Element {
  return <>{props.routeStore.showingSpinner && <Overlay type={'fixed'} spinner={{}} />}</>;
}

export default inject('routeStore')(observer(ContentPageOverlay));
